module.exports = __webpack_public_path__ + "static/media/sales-bg.70fe037a.jpg";